/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 1 hook(s) need dependency review; fix each and remove this directive */
import { createContext, useEffect } from "react";
import { useSelector } from "react-redux";
import i18n from "@i18n";
import { RootState } from "@Reducers/index";

const LanguageContext = createContext({
  preferredLanguage: "en",
});

const isReactNative = typeof document === "undefined";

function ProviderLanguage(props: any) {
  const preferredLanguage = useSelector((state: RootState) => state.preferredLanguage);

  useEffect(() => {
    const isRTL = preferredLanguage === "ar";
    props.isRTLCallback?.(isRTL);
    i18n.changeLanguage(preferredLanguage);
    if (!isReactNative) {
      globalThis.localStorage.setItem("preferredLanguage", preferredLanguage);
    }
  }, [preferredLanguage]);

  const Provider = LanguageContext.Provider as any;
  return (
    <Provider
      value={{
        preferredLanguage,
      }}
    >
      {props.children}
    </Provider>
  );
}

export default ProviderLanguage;
